module.exports = __webpack_public_path__ + "static/media/Anita Felbrich-Smit.340bfe39.jpg";